(() => {
  if (window.__hpProductPresentation) return;
  window.__hpProductPresentation = true;

  const titleSelector = [
    '.product-title', '.cart-product__title', '.line-item__title', '.shop-the-look__product-title',
    '.hp-video-stl__product-title', '.product-sticky-bar__mobile-title', '.product-sticky-bar__info .h6',
    '[data-hp-product-title]'
  ].join(',');
  const priceSelector = '.price-list:not(.price-list--unit), .product-card__cart-price-badge-row';
  const titles = new Map();
  const prices = new Set();
  const resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  const strings = window.themeVariables?.strings ?? {};
  const expandLabel = strings.productNameExpand || '';
  const collapseLabel = strings.productNameCollapse || '';
  let queued = false;
  let nextId = 0;

  function enhanceTitle(source) {
    if (source.closest('.hp-product-name') || !source.textContent.trim()) return;
    const link = source.closest('a');
    const target = link && link.textContent.trim() === source.textContent.trim() ? link : source;
    const wrapper = document.createElement('div');
    wrapper.className = 'hp-product-name';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'hp-product-name__toggle';
    button.textContent = '…';
    button.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', expandLabel);
    wrapper.style.setProperty('--hp-product-name-size', getComputedStyle(source).fontSize);
    target.classList.add('hp-product-name__text');
    if (!target.id) target.id = `hp-product-name-${++nextId}`;
    button.setAttribute('aria-controls', target.id);
    target.before(wrapper);
    wrapper.append(target, button);
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const expanded = wrapper.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(expanded));
      button.setAttribute('aria-label', expanded ? collapseLabel : expandLabel);
    });
    titles.set(wrapper, { target, button });
    resizeObserver?.observe(wrapper);
  }

  function measureTitle(wrapper, { target, button }) {
    if (!wrapper.clientWidth) return;
    const expanded = wrapper.classList.contains('is-expanded');
    wrapper.classList.remove('is-expanded');
    // Düğme gizlenmeden ölçülür (gizlemek klavye odağını düşürüyordu): metin, düğmesiz tam genişliğe sığıyor mu?
    const contentWidth = Math.max(target.scrollWidth, ...Array.from(target.querySelectorAll('h1, h2, h3, p, a'), element => element.scrollWidth));
    const overflow = contentWidth > wrapper.clientWidth + 1;
    button.hidden = !overflow;
    wrapper.classList.toggle('is-expanded', expanded && overflow);
    button.setAttribute('aria-expanded', String(expanded && overflow));
    button.setAttribute('aria-label', expanded && overflow ? collapseLabel : expandLabel);
  }

  function measurePrice(price) {
    if (!price.clientWidth) return;
    price.style.removeProperty('--hp-product-price-fit');
    const size = parseFloat(getComputedStyle(price).fontSize);
    const available = price.clientWidth;
    if (price.scrollWidth > available + 1) {
      const fitted = Math.max(9, Math.floor(size * available / price.scrollWidth * 10) / 10);
      price.style.setProperty('--hp-product-price-fit', `${fitted}px`);
    }
  }

  function refresh() {
    queued = false;
    document.querySelectorAll(titleSelector).forEach(enhanceTitle);
    document.querySelectorAll(priceSelector).forEach(price => {
      if (prices.has(price)) return;
      prices.add(price);
      resizeObserver?.observe(price);
    });
    for (const [wrapper, data] of titles) {
      if (!wrapper.isConnected) {
        resizeObserver?.unobserve(wrapper);
        titles.delete(wrapper);
      } else {
        measureTitle(wrapper, data);
      }
    }
    for (const price of prices) {
      if (!price.isConnected) {
        resizeObserver?.unobserve(price);
        prices.delete(price);
      } else {
        measurePrice(price);
      }
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }

  function init() {
    refresh();
    new MutationObserver(records => {
      if (records.some(record => record.type === 'characterData' || [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1))) schedule();
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    document.fonts?.ready.then(schedule);
    document.fonts?.addEventListener('loadingdone', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
